import type { Reducer } from 'redux';

import type { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import type { LegacyYammer } from './types';

export type LegacyYammerAction = SessionConfigureAction;

const initialState: LegacyYammer = {
  clientId: '',
};

const reducer: Reducer<LegacyYammer, LegacyYammerAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.legacyYammer;
    default:
      return state;
  }
};

export default reducer;
